import {
  CREATE_SITE_GROUP_WEATHER_CONFIGURATION,
  DELETE_SITE_GROUP_WEATHER_CONFIGURATION,
  EDIT_SITE_GROUP_WEATHER_CONFIGURATION,
  RECEIVE_SITE_GROUP_WEATHER_CONFIGURATIONS,
  REQUEST_SITE_GROUP_WEATHER_CONFIGURATION,
  REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP,
} from '@sophocles/entities/SiteGroupWeatherConfiguration/siteGroupWeatherConfigurationActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITE_GROUP_WEATHER_CONFIGURATIONS: // Read
      return state.merge(action.siteGroupWeatherConfigurations);
    case DELETE_SITE_GROUP_WEATHER_CONFIGURATION: // Delete
      return state.delete(action.siteGroupWeatherConfiguration.toString());
    case EDIT_SITE_GROUP_WEATHER_CONFIGURATION: // Update
    case CREATE_SITE_GROUP_WEATHER_CONFIGURATION: // Create
    case REQUEST_SITE_GROUP_WEATHER_CONFIGURATION:
    case REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP:
    default:
      return state;
  }
}

export function siteGroupWeatherConfigurationReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_SITE_GROUP_WEATHER_CONFIGURATION:
    case DELETE_SITE_GROUP_WEATHER_CONFIGURATION:
    case RECEIVE_SITE_GROUP_WEATHER_CONFIGURATIONS:
    case EDIT_SITE_GROUP_WEATHER_CONFIGURATION:
    case REQUEST_SITE_GROUP_WEATHER_CONFIGURATION:
    case REQUEST_SITE_GROUP_WEATHER_CONFIGURATION_FOR_SITE_GROUP:
      return getState(state, action);
    default:
      return state;
  }
}
